import type { GameDescriptor } from '@everyturn/engine/runtime';

export const ginRummyDescriptor = {
  gameId: 'gin-rummy',
  displayName: 'Gin Rummy',
  seats: ['south', 'north'],
  minPlayers: 2,
  maxPlayers: 2,
  defaultSeat: 'south',
  layoutId: 'gin-rummy',
  discovery: {
    summary:
      'Draw and discard head-to-head to form 3+ card sets and runs. Knock with 10 or less deadwood, or hold out for Gin.',
    family: 'Draw & Meld',
    playerLabel: '2 Players (1v1)',
    formatLabel: 'To 100 pts',
  },
} as const satisfies GameDescriptor;
